import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import GetProxy from "../../common/GetProxy";
import { handleResponseCode } from "../../../app/utilities/helpers";
import moment from "moment";

const proxy = GetProxy();
const cookies = new Cookies();

export const getRitmComplianceStatusCountAPI = createAsyncThunk(
    "post/getRitmComplianceStatusCountAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarRITM/getComplianceStatusCount`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getRitmTrendChartAPI = createAsyncThunk(
    "post/getRitmTrendChartAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarRITM/getTrendChart`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getRitmReasonDetailsPopUpAPI = createAsyncThunk(
    "get/getRitmReasonDetailsPopUpAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { ritmNumber } = props;
            const response = await fetch(`${proxy}/api/v1/sirarRITM/getReasonDetailsPopUp/${ritmNumber}`, {
                method: 'GET',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getRitmServersListAPI = createAsyncThunk(
    "get/getRitmServersListAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { ritmNumber } = props;
            const response = await fetch(`${proxy}/api/v1/sirarINC/getServersOrHostList/${ritmNumber}`, {
                method: 'GET',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

export const getRitmListAPI = createAsyncThunk(
    "post/getRitmListAPI",
    async (props) => {
        const apiToken = cookies.get("apitoken");
        const username = cookies.get("username");
        try {
            const { pageNumber, itemsPerPage, payload } = props;
            const response = await fetch(`${proxy}/api/v1/sirarRITM/list/${pageNumber}/${itemsPerPage}`, {
                method: 'POST',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "CMTS-API-TOKEN": apiToken,
                    USERNAME: username,
                },
                body: JSON.stringify(payload)
            });
            handleResponseCode(response);
            const data = await response.json();
            return response.ok ? data : Promise.reject(data);
        } catch (error) {
            console.error("Error:", error);
            throw error;
        }
    }
);

const initialState = {
    selectedFiltersData: {
        selectedDate: {
            timePicker: false,
            maxDate: moment().toDate(),
            autoApply: true,
            startDate: moment().startOf("month").format('YYYY-MM-DDT00:00:00.000'),
            endDate: moment().add(1, 'day').startOf('day').format('YYYY-MM-DDT00:00:00.000'),
            locale: {
                format: 'DD/MM/YYYY',
            },
        },
    },
    activeTabKey: "NonCompliantFindings",
    tablereload: false,

    ritmComplianceStatusData: [],
    ritmComplianceStatusLoading: false,

    ritmTrendChartData: [],
    ritmTrendChartLoading: false,

    ritmListData: [],
    ritmListLoading: false,

    error: false,
};

export const RitmSlice = createSlice({
    name: "RitmSlice",
    initialState,
    reducers: {
        resetRitmSliceData: () => {
            return initialState;
        },
        setRitmSelectedFiltersData: (state, action) => {
            state.selectedFiltersData = action.payload;
        },
        setRitmActiveTabKey: (state, action) => {
            state.activeTabKey = action.payload;
        },
        setRitmTableReload: (state, action) => {
            state.tablereload = action.payload;
        },
        setRitmTableData: (state, action) => {
            state.ritmListData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            // getRitmComplianceStatusCountAPI
            .addCase(getRitmComplianceStatusCountAPI.pending, (state) => {
                state.ritmComplianceStatusLoading = true;
                state.error = false;
            })
            .addCase(getRitmComplianceStatusCountAPI.fulfilled, (state, action) => {
                state.ritmComplianceStatusData = action.payload;
                state.ritmComplianceStatusLoading = false;
                state.error = false;
            })
            .addCase(getRitmComplianceStatusCountAPI.rejected, (state) => {
                state.ritmComplianceStatusLoading = false;
                state.ritmComplianceStatusData = [];
                state.error = true;
            })

            // getRitmTrendChartAPI
            .addCase(getRitmTrendChartAPI.pending, (state) => {
                state.ritmTrendChartLoading = true;
                state.error = false;
            })
            .addCase(getRitmTrendChartAPI.fulfilled, (state, action) => {
                state.ritmTrendChartData = action.payload;
                state.ritmTrendChartLoading = false;
                state.error = false;
            })
            .addCase(getRitmTrendChartAPI.rejected, (state) => {
                state.ritmTrendChartLoading = false;
                state.ritmTrendChartData = [];
                state.error = true;
            })

            // getRitmListAPI
            .addCase(getRitmListAPI.pending, (state) => {
                state.ritmListLoading = true;
                state.error = false;
            })
            .addCase(getRitmListAPI.fulfilled, (state, action) => {
                state.ritmListData = action.payload;
                state.ritmListLoading = false;
                state.error = false;
            })
            .addCase(getRitmListAPI.rejected, (state) => {
                state.ritmListLoading = false;
                state.ritmListData = [];
                state.error = true;
            });
    }
});

export const {
    resetRitmSliceData,
    setRitmSelectedFiltersData,
    setRitmActiveTabKey,
    setRitmTableReload,
    setRitmTableData,
} = RitmSlice.actions;

export default RitmSlice.reducer;
